import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {WidgetModel} from "../../../models/widget.model";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {AgentModel} from "../../../../agents/angular/models/agent.model";
import {TaskModel} from "../../../../tasks/models/task.model";
import {RouterService} from "../../../../commons/angular/services/router.service";
import * as moment from "moment/moment";

require('./agent-progress-table-widget.scss');
@Component({
  standalone: false,
  selector: 'app-agent-progress-table-widget',
  templateUrl: './agent-progress-table-widget.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgentProgressTableWidgetComponent implements DoCheck, OnChanges, AfterViewInit {

  @Input() widget: WidgetModel;
  @Input() dateRange: any;
  @Input() data: any;
  @Input() isLoading: boolean;
  @Output() fetchNextEvent = new EventEmitter<null>();
  @Output() askToEnableGpsEvent = new EventEmitter<{ agentPnType: string, agentId: string }>();
  @Output() askToEnableGpsPermissionsEvent = new EventEmitter<{ agentPnType: string, agentId: string }>();

  @ViewChild('header', {static: false}) header: ElementRef;
  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public enabledColumnsMap: any;

  constructor(@Inject('agentDialogService') private agentDialogService, @Inject('agentsService') private agentsService,
              @Inject(RouterService) private routerService: RouterService) {
  }

  ngDoCheck() {
    this.cdkVirtualScrollViewport?.checkViewportSize();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      this.cdkVirtualScrollViewport?.checkViewportSize();
    }
    if (changes.widget) {
      this.initEnabledColumnsMap();
    }
  }

  ngAfterViewInit(): void {
    const div1 = this.header.nativeElement;
    const div2 = this.cdkVirtualScrollViewport.elementRef.nativeElement;

    div2.addEventListener('scroll', (e) => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    });
  }

  getNextBatch() {
    if (this.cdkVirtualScrollViewport.measureScrollOffset('bottom') < 50) {
      this.fetchNextEvent.emit();
    }
  }

  onSendNotificationToAgents(agentPnType: string, agentId?: string) {
    this.agentsService.sendNotification(
      agentPnType,
      [agentId]);
  }

  onSwapServices(agent: AgentModel) {
    this.agentDialogService.swapDeliveries(agent, event);
  }

  onViewAgentTasks(agent: AgentModel, tasks: TaskModel[]) {
    this.agentDialogService.viewAgentTrackingTasks(agent, tasks, {...this.dateRange});
  }

  onViewAgentItinerary(agentId: string) {
    this.routerService.routeToNewTab('agents-itinerary.list', {agentId: agentId});
  }

  private initEnabledColumnsMap() {
    this.enabledColumnsMap = {};

    this.widget.columns.forEach((c) => {
      this.enabledColumnsMap[c.name] = {
        enabled: true,
        name: c.name
      };
    })
  }
}
